import React, { Component } from 'react';
import '../../css/PushNotifications.css'

class PushNotifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notifications: [],
    };
    this.addNotification = this.addNotification.bind(this);
  }

  addNotification(action) {
    const notification = this.createNotification(action);
    this.setState((prevState) => ({
      notifications: [...prevState.notifications, notification],
    }));
    if (notification.timeout > 0) {
      setTimeout(() => {
        this.removeNotification(notification.id);
      }, notification.timeout);
    }
  }

  createNotification(action) {
    const id = new Date().getTime();
    const defaultTimeout = 3000;
  
    const types = {
      0: { title: 'Error', color: 'red', icon: 'fa-times-circle' },
      1: { title: 'Éxito', color: 'green', icon: 'fa-check-circle' },
      2: { title: 'Información', color: 'blue', icon: 'fa-info-circle' },
      3: { title: 'Advertencia', color: 'orange', icon: 'fa-exclamation-circle' },
      4: { title: 'Notificación', color: 'gray', icon: 'fa-bell' }
    };
  
    const notificationType = types[action.type];
  
    const notification = {
      id,
      title: action.title || notificationType.title,
      color: notificationType.color,
      icon: notificationType.icon,
      message: action.message || '',
      timeout: typeof action.timeOut === 'number' ? action.timeOut : defaultTimeout
    };
  
    return notification;
  }
  

  removeNotification(id) {
    this.setState((prevState) => ({
      notifications: prevState.notifications.filter((notification) => notification.id !== id),
    }));
  }

  render() {
    const { notifications } = this.state;
    return (
      <div className="push-notification-container">
        {notifications.map((notification) => (
          <div key={notification.id} className="push-notification" style={{ backgroundColor: notification.color}}>
            <div className="push-notification-header">
              <i className={`fa ${notification.icon} push-notification-icon`} aria-hidden="true"></i>
              <span className="push-notification-title">{notification.title}</span>
              <button className="push-close-btn" onClick={() => this.removeNotification(notification.id)}>
                &times;
              </button>
            </div>
            <p className="push-notification-message">{notification.message}</p>
          </div>
        ))}
      </div>
    );
  }
}

export default PushNotifications;